type RepeatIconProps = { size: number; stroke: number }

// Repeat glyph of the card pill and the popover title.
export const RepeatIcon = ({ size, stroke }: RepeatIconProps) => (
  <svg
    aria-hidden='true'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={stroke}
    strokeLinecap='round'
    strokeLinejoin='round'>
    <path d='m17 2 4 4-4 4' />
    <path d='M3 11v-1a4 4 0 0 1 4-4h14' />
    <path d='m7 22-4-4 4-4' />
    <path d='M21 13v1a4 4 0 0 1-4 4H3' />
  </svg>
)

// Triangle of the per-row warning strip.
export const WarningIcon = () => (
  <svg
    aria-hidden='true'
    width='13'
    height='13'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'>
    <path d='M12 9v4' />
    <path d='M12 17h.01' />
    <path d='M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z' />
  </svg>
)
